import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Lightbulb, Calendar, Luggage, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';

const tipsSections = [
  {
    id: 1,
    icon: Calendar,
    title: 'Mejores Épocas para Visitar',
    content: 'Evita las multitudes yendo en primavera (marzo-mayo) o otoño (septiembre-noviembre). El clima es perfecto, hay menos filas y ¡fiestas especiales como Halloween o Navidad mágica! Revisa el calendario de eventos antes de reservar para no perderte shows exclusivos.'
  },
  {
    id: 2,
    icon: Luggage,
    title: 'Qué Empacar Esencial',
    content: 'Ropa cómoda para caminar (sneakers anti-fatiga son clave), protector solar resistente al agua, botellas reutilizables, snacks saludables y cargadores portátiles. No olvides ponchos para lluvia repentina y ropa de capas para las noches frescas. ¡Viaja ligero pero preparado!'
  },
  {
    id: 3,
    icon: DollarSign,
    title: 'Cómo Ahorrar Dinero',
    content: 'Compra paquetes todo-incluido para boletos + hotel. Llega temprano para evitar extras como express passes. Come en spots fuera del parque para ahorrar, usa apps de descuentos y viaja en temporada baja. Nuestro tip pro: ¡Cotiza con nosotros para precios imbatibles!'
  },
  {
    id: 4,
    icon: Lightbulb,
    title: 'Trucos para Disfrutar Más',
    content: 'Descarga las apps oficiales de Disney/Universal para mapas en tiempo real y reservas de comida. Usa el FastPass para atracciones top. Toma breaks en shows para descansar pies. Y recuerda: ¡la magia está en los detalles, como fotos con personajes a primera hora!'
  }
];

const Tips = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100 py-20 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="flex items-center text-gray-700 mb-8 hover:text-green-500 transition-colors text-sm sm:text-base"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Volver al Inicio
        </Link>
        
        <motion.h1 
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12 bg-gradient-to-r from-green-500 to-blue-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Consejos de Viaje Mágicos ✨
        </motion.h1>
        
        <div className="space-y-8">
          {tipsSections.map((section, index) => {
            const Icon = section.icon;
            return (
              <motion.div
                key={section.id}
                className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">{section.title}</h2>
                    <p className="text-gray-600 leading-relaxed text-sm sm:text-base">{section.content}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
        
        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-600 mb-6 text-sm sm:text-base">¿Listo para aplicar estos tips? ¡Empieza planeando tu aventura!</p>
          <Link
            to="/#quote"
            className="inline-block bg-gradient-to-r from-green-500 to-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base hover:scale-105 transition-all shadow-lg"
          >
            Cotizar Mi Viaje
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default Tips;